import React, {useEffect, useState} from 'react';
import OrderProductionTable from "../../../components/UI/table/orders/organization/production/OrderProductionTable";
import OrderService from "../../../API/orders/orders/organization/OrderService";
import OrderUtil from "../../../utils/orders/OrderUtil";
import TypeJobService from "../../../API/orders/orders/organization/TypeJobService";
import {EditLocalStoragePagesData} from "../../../utils/EditLocalStoragePagesData";
import {BreadcrumbsComponent} from "../../../components/UI/breadcrumb/BreadcrumbComponent";
import {Box} from "@mui/system";
import ModalAlert from "../../../components/UI/table/customer-detales/ModalAlert";
import {constantsErrorMessages} from "../../../Constants";
import Typography from "@mui/material/Typography";
import {calcFilterData} from "../../../utils/common/calcFilterData";
import {OrderProductionTableFiltererData} from "../../../data/FilterTables/OrderProductionTableFiltererData";
import DataUtil from "../../../utils/common/DataUtil";
import CircularProgress from "@mui/material/CircularProgress";

const OrdersProduction = () => {

    const [data, setData] = useState([]);
    const [additionallyColumn, setAdditionallyColumn] = useState([]);
    const [customerList, setCustomerList] = useState([]);
    const [nameList, setNameList] = useState([]);
    const [attributeList, setAttributeList] = useState([]);
    const [planningList, setPlanningList] = useState([]);
    const [alertData, setAlertData] = useState({});
    const [filteredData, setFilteredData] = useState(data)
    const [globalFilter, setGlobalFilter] = useState('');
    const [columnsFilter, setColumnsFilter] = useState([]);
    const [shipped, setShipped] = useState(false)
    const [isLoading, setIsLoading] = useState(true)
    const [tableOptions, setTableOptions] = useState({
        pageIndex: 0,
        pageSize: 100,
        totalElements: 0,
        searchData: ""
    })
    const tableOptionsHandle = (nextState) => {
        setTableOptions(nextState)
        if (nextState.pageSize !== tableOptions.pageSize) {
            EditLocalStoragePagesData("organization/orders-production", "pageSize", nextState.pageSize)
        }
    }
    const handleModalAlert = (message, type = "error") => {
        setAlertData({
            type: type,
            open: true,
            message: type === "success" ? message : message.response?.data?.message || constantsErrorMessages[message.response?.status] || message.message
        })
    }
    const handleSearchQuery = (searchQuery, prevData, pageSize, isColumnFilters) => {
        const newColumnsFilter = isColumnFilters ? searchQuery : columnsFilter
        const newGlobalFilter = isColumnFilters ? globalFilter : searchQuery || ""

        const data = [...prevData]
        const globalFilterData = newGlobalFilter ? calcFilterData(data, newGlobalFilter, OrderProductionTableFiltererData) : data
        const newData = newColumnsFilter.reduce((accumulator, currentValue) => {
            return calcFilterData(accumulator, currentValue?.value, [OrderProductionTableFiltererData.find(el => el.idFromColumnFilter === currentValue.id)])
        }, globalFilterData);

        setFilteredData(newData)

        tableOptionsHandle({
            ...tableOptions,
            totalElements: newData.length,
            pageSize: pageSize ? pageSize : tableOptions?.pageSize
        })

        if (isColumnFilters) {
            setColumnsFilter(searchQuery)
        } else {
            setGlobalFilter(searchQuery || "")
            if (searchQuery !== globalFilter) {
                EditLocalStoragePagesData(`organization/orders-production`, "searchQuery", searchQuery)
            }
        }
    }

    const getStartPageSize = () => {
        const pagesData = JSON.parse(localStorage.getItem('pagesData')) || {}
        const isProductionShipped = JSON.parse(localStorage.getItem('isProductionShipped'))

        const pageSize = pagesData["organization/orders-production"]?.pageSize
        const searchQuery = pagesData["organization/orders-production"]?.searchQuery

        return {searchQuery, pageSize, isProductionShipped}
    }
    const setLists = (data) => {
        setCustomerList(OrderUtil.getListField(data, 'customerName'));
        setNameList(OrderUtil.getListField(data, 'header'));
        setAttributeList(OrderUtil.getStatuses(data, 'attributes'));
        setPlanningList(OrderUtil.getListField(data, 'state'));
    }

    const getProductionData = (searchQuery, pageSize, isProductionShipped) => {
        setShipped(isProductionShipped)
        const api = isProductionShipped ? OrderService.getOrdersProductionShipped : OrderService.getOrdersProduction

        api().then(function (response) {
            const data = response.data;
            setData(data);
            handleSearchQuery(searchQuery, data, pageSize)
            setLists(data)
        })
            .catch(function (error) {
                handleModalAlert(error);
            })
            .finally(() => setIsLoading(false))
    }
    useEffect(() => {
        const {searchQuery, pageSize, isProductionShipped} = getStartPageSize()
        TypeJobService.getAllByOrganizationId().then(function (response) {
            const data = response.data
            data.sort((a, b) => b.outputPriority - a.outputPriority);
            setAdditionallyColumn(data);
        })
            .catch(function (error) {
                handleModalAlert(error);
            });

        getProductionData(searchQuery, pageSize, isProductionShipped)
    }, []);

    return (
        <Box sx={{padding: "0 30px"}}>
            <BreadcrumbsComponent
                page={`Производство`}
                path={[{name: "Главная", href: "/"}]}/>
            <Typography sx={{fontSize: "24px", fontWeight: 700}}>
                Производство
            </Typography>
            {isLoading ?
                <Box sx={{
                    height: `calc(100vh - 450px)`,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                    <CircularProgress disableShrink/>
                </Box> : <OrderProductionTable
                    data={data}
                    setData={setData}
                    customerList={customerList}
                    nameList={nameList}
                    attributeList={attributeList}
                    planningList={planningList}
                    isColumnPlan={true}
                    additionallyColumn={additionallyColumn}
                    tableOptions={tableOptions}
                    tableOptionsHandle={tableOptionsHandle}
                    handleModalAlert={handleModalAlert}
                    globalFilter={globalFilter}
                    filteredData={filteredData}
                    handleSearchQuery={handleSearchQuery}
                    columnsFilter={columnsFilter}
                    setLists={setLists}
                    shipped={shipped}
                    getProductionData={getProductionData}
                />
            }
            <ModalAlert
                data={alertData}
                onClose={() => setAlertData((alert) => ({...alert, open: false}))}
            />
        </Box>
    );
};

export default OrdersProduction;